import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ChatInterface } from '../../components/Chat/ChatInterface';
import { chatService } from './chatService';
import { useChat } from '../../hooks/useChat';
import { Loader2 } from 'lucide-react';

export const ChatOnboardingPage = () => {
  const navigate = useNavigate();
  const { userId } = useAuth();

  const handleContinue = () => {
    if (userId) {
      localStorage.removeItem(`vision_${userId}`);
    }
    navigate('/home');
  };

  const {
    messages,
    showContinueButton,
    isLoading,
    isSending,
    sendMessage,
    autoContinueTriggered
  } = useChat({
    chatService,
    categoryPrompt: 'chat_to_summary_profile',
    fallbackMessage: "Hey there! We're going to map out your 3-year vision. This will only take about 3 minutes and will help NuroLeap become the bridge to your dream life. Most people wildly underestimate what's possible in three years - so don't hold back. Before we begin, what's your first name so I can personalize the session?",
    errorMessage: "I'm sorry, there was an error processing your message. Please try again.",
    autoContinue: true,
    onAutoContinue: handleContinue
  });

  if (isLoading) {
    return (
      <div className="h-screen bg-[#1a1a1a] flex flex-col items-center justify-center">
        <div className="text-center space-y-4">
          <Loader2 className="w-12 h-12 text-[#79c9cb] animate-spin mx-auto" />
          <p className="text-white text-lg">Loading your personalized experience...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen bg-[#1a1a1a] flex flex-col">
      <div className="flex-1 flex flex-col mx-4 sm:mx-8 md:mx-16 lg:mx-32 my-4 sm:my-6 md:my-8 lg:my-10">
        <ChatInterface
          messages={messages}
          onSendMessage={sendMessage}
          placeholder="Type your answers here..."
          isLoading={isSending}
          showContinueButton={showContinueButton}
          onContinue={handleContinue}
          autoContinueMode={autoContinueTriggered}
        />

      </div>
    </div>
  );
};